// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1t0-I","right":"styles_right__1tA02"};